var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25814 6.04377C5.47508 6.2607 5.8268 6.2607 6.04373 6.04377C6.26066 5.82684 6.26067 5.47512 6.04373 5.25819L3.88878 3.10322L6.04373 0.948275C6.26066 0.731342 6.26066 0.379624 6.04373 0.16269C5.8268 -0.0542432 5.47508 -0.0542433 5.25815 0.16269L3.1032 2.31764L0.948236 0.162688C0.731303 -0.0542445 0.379584 -0.0542439 0.162651 0.162689C-0.0542827 0.379623 -0.0542827 0.731342 0.162651 0.948276L2.3176 3.10322L0.162651 5.25817C-0.0542829 5.4751 -0.0542825 5.82682 0.162651 6.04376C0.379585 6.26069 0.731302 6.26069 0.948237 6.04376L3.1032 3.88882L5.25814 6.04377Z",
    fill: "#714FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/Cross.014b17c2624613fba8819ea2852883c1.svg";
export { ForwardRef as ReactComponent };